import { nanoid } from 'nanoid';
import styled from 'styled-components';

interface HighLightedTextProps {
  text: string;
  highlightText: string;
  size: number;
  defaultColor: string;
  highlightColor: string;
}

export const HighLightedText = (props: HighLightedTextProps) => {
  const { text, highlightText, size, defaultColor, highlightColor } = props;
  if (!text) {
    return null;
  }

  if (!highlightText.trim()) {
    return (
      <HighLighted color={defaultColor} size={size}>
        {text}
      </HighLighted>
    );
  }

  const regex = new RegExp(`(${highlightText})`, 'gi');

  const parts = text
    .split(regex)
    .map((part) => ({ key: nanoid(), text: part }));

  return (
    <span>
      {parts
        .filter((part) => part)
        .map((part) => {
          const color = regex.test(part.text) ? highlightColor : defaultColor;
          return (
            <HighLighted key={part.key} color={color} size={size}>
              {part.text}
            </HighLighted>
          );
        })}
    </span>
  );
};

const HighLighted = styled.span<{ color: string; size: number }>`
  color: ${(props) => props.color};
  font-size: ${(props) => props.size}px;
`;
